<vb-title [title]="(isChangePassword ? 'ChangePassword' : 'Title_ForgotPassword') | translate"></vb-title>

<vb-auth-layout>

	<div [hidden]="!status.processing">
		<vb-loading-spinner [msg]="'ForgotPassword_ProcessingMessage' | translate" [size]="'large'"></vb-loading-spinner>
	</div>

	<div [hidden]="status.processing">

		<div [ngClass]="[authLayoutStyles.centered, authLayoutStyles.logoWrapper]">
			<branding-logo></branding-logo>
		</div>

		<div [ngClass]="authLayoutStyles.heading">
			<h2>{{ (isChangePassword ? 'ChangePassword' : 'ForgotPassword_Heading') | translate }}</h2>
		</div>

		<form #initiateResetPasswordForm="ngForm" [ngClass]="authLayoutStyles.authForm" name="initiateResetPasswordForm" (submit)="submit()">
			<div [hidden]="!status.error" class="system-msg">
				<div [ngSwitch]="lastError">
					<p *ngSwitchCase="'InitiatePasswordReset_CommandDenied'">
						{{ (isChangePassword ? 'ChangePassword_CommandDenied' : 'ForgotPassword_CommandDenied') | translate }}
					</p>
					<p *ngSwitchDefault>{{ 'UnhandledError' | translate }}</p>
				</div>
				<a uiSref="login" vbBtnPrimary>{{ 'ReturnToLogin' | translate }}</a>
			</div>

			<div [hidden]="!status.success" class="system-msg">
				{{ 'ForgotPassword_EmailSent' | translate }}
			</div>

			<div class="margin-top-20">
				<label for="username">{{ 'Username' | translate }}</label>
				<input type="text" id="username" name="username" class="form-control theme-header-bg theme-header-txt" [attr.aria-label]="'Username' | translate" [placeholder]="'Username_Placeholder' | translate" [(ngModel)]="username" [disabled]="isChangePassword" vbAutoFocus required>
			</div>

			<div class="margin-top-20">
				<div [hidden]="!status.active">
					<button type="submit" [ngClass]="authLayoutStyles.authBtn" [disabled]="initiateResetPasswordForm.invalid" vbBtnPrimary>
						{{ 'Submit' | translate }}
					</button>
					<a class="margin-top-10" [ngClass]="authLayoutStyles.authBtn" uiSref="login" vbBtnSecondary>{{ 'Cancel' | translate }}</a>
				</div>

				<a [hidden]="!status.success" [ngClass]="authLayoutStyles.authBtn" uiSref="login" vbBtnPrimary>
					{{ 'SignIn' | translate }}
				</a>
			</div>
		</form>

	</div>

</vb-auth-layout>
